































import { Vue } from 'vue-property-decorator';

export default class PayoutStatus extends Vue {
  get tPrefix() {
    return 'sellCoins.overview.cards.payout.modal.tooltip';
  }
}
